import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import { StopContainer } from "./styles";
import { StopDivisionProps } from "./types";

/**
 * Componente StopDivision
 * @param {string} waitingTime - Tempo entre voos.
 * @returns {ReactNode} Componente.
 */
export const StopDivision: React.FC<StopDivisionProps> = ({ waitingTime }) => (
  <StopContainer>
    <Icon library="go" name="GoDotFill" size="small" color="red" />
    <Typography variant="caption" color="red" weight="light">
      Tempo entre voos: {waitingTime}
    </Typography>
  </StopContainer>
);
